import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { max: Number }

  trim(event) {
    const editor = event.target.editor
    const length = editor.getDocument().toString().length - 1
    if (length <= this.maxValue) return

    editor.setSelectedRange([this.maxValue, length])
    editor.deleteInDirection("backward")
  }
}
